// The FAQ page's buckets. Each stored FAQ record carries the bucket id in its
// `category` field, so the order, emoji and wording of the buckets live here —
// the same way the site's other taxonomies work. Emoji come from the map pins'
// set (see PlacePin) so the section speaks the same visual language.
export const FAQ_CATEGORIES = [
  { id: "basics", emoji: "📋", label: "The Basics" },
  { id: "getting-around", emoji: "🚗", label: "Getting Around" },
  { id: "money", emoji: "💵", label: "Money & Costs" },
  { id: "beaches-weather", emoji: "🏖️", label: "Beaches & Weather" },
  { id: "food-drink", emoji: "🍴", label: "Food & Drink" },
  { id: "tours", emoji: "🧭", label: "Tours & Booking" },
  { id: "safety", emoji: "🛟", label: "Safety & Health" },
  { id: "culture", emoji: "🏛️", label: "Culture & Etiquette" },
];

export const FAQ_CATEGORY_BY_ID = Object.fromEntries(FAQ_CATEGORIES.map((c) => [c.id, c]));